module.exports = __webpack_public_path__ + "img/icon-navigation-add-light.1b50c3a9.svg";